// Angular
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnInit,
} from '@angular/core';

// Local library
import { WagerFacade } from '@amwager/wager/data-access';
import { CommonModule } from '@angular/common';
import { ticketRequest } from '@amwager/util-ts';
import { FundingComponent } from '@amwager/funding/feature-ion';

// Ionic
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent,
  IonItem,
  IonGrid,
  IonRow,
  IonCol,
  ModalController,
  NavParams,
  AlertController
} from '@ionic/angular/standalone';

// Third party
import * as _ from 'lodash';

@Component({
  selector: 'feature-ion-abc',
  templateUrl: './abc.component.html',
  styleUrls: ['./abc.component.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
    IonItem,
    IonGrid,
    IonRow,
    IonCol,
    CommonModule
  ],
  standalone: true
})
export class AbcComponent implements OnInit {

  betNow!: (event: any) => void;

  eventName!: any;
  abcTicket!: any;
  selectedRace!: any;

  balanceAmount!: any;
  abcHolder!: any;
  abcAmountHolder!: any;
  minPayout!: any;
  maxPayout!: any;

  constructor(
    private readonly alertCtrl: AlertController,
    private readonly modalCtrl: ModalController,
    private readonly navParams: NavParams,
    private readonly wagerFacade: WagerFacade,
    private readonly elementRef: ElementRef,
    private readonly cdRef: ChangeDetectorRef,
    private readonly ngZone: NgZone
  ) { }

  ngOnInit() {
    this.eventName = this.navParams.get('eventName');
    this.abcTicket = this.navParams.get('abcTicket');
    this.selectedRace = this.navParams.get('selectedRace');
    this.balanceAmount = this.navParams.get('balanceAmount');
  }

  createNewABCTicket(isIndividual: boolean, typeIs?: string): any {
    const wagersList = [];
    for(let i=0;i<this.abcTicket.length;i++) {
      if(
        (this.abcTicket[i].submitted === undefined || this.abcTicket[i].submitted === false)
        &&
        (this.abcTicket[i].saved === undefined || this.abcTicket[i].saved === false)
        &&
        (this.abcTicket[i].removed === undefined || this.abcTicket[i].removed === false)
      ) {
        for(let j = 0; j < this.abcTicket[i].ABCTicket.Wagers.length; j++) {
          wagersList.push(this.abcTicket[i].ABCTicket.Wagers[j]);
        }
      }
    }

    return new ticketRequest(
      this.abcTicket[0].ABCTicket.RunId,
      this.abcTicket[0].ABCTicket.EventId,
      this.abcTicket[0].ABCTicket.RaceId,
      wagersList,
      isIndividual ? 0 : 3,
      undefined
    );
  }

  submitBet(index: any): void {

    if (this.abcTicket[index].ABCTicket.calcAmount() > this.balanceAmount) {
      this.showAlertInfo('Info', 'Insufficient Funds.', 'Deposit Now');
      return;
    }

    if(
      this.abcTicket[index].ABCTicket.Error === undefined ||
      this.abcTicket[index].ABCTicket.Error === null
    ) {
      this.abcTicket[index].submitted = true;
      this.abcTicket[index].ABCTicket.DutchType = 0;
      this.betNow({
        betType: 'bet-now',
        typeIs: 'abc',
        abcTicket: this.abcTicket[index].ABCTicket
      });
    } else {
      const errMsg = this.elementRef.nativeElement.querySelectorAll(
        '.current-bets #error-index-' + index
      );

      _.forEach(errMsg, (html: HTMLElement) => {
        if (html)
          html.innerHTML = this.abcTicket[index].ABCTicket.Error;
      });

      // if (errMsg)
      //   errMsg.innerHTML = this.abcTicket[index].ABCTicket.Error;
    }
  }

  saveBet(index: any): void {
    this.abcTicket[index].saved = true;
    this.abcTicket[index].ABCTicket.DutchType = 0;
    this.betNow({
      betType: 'save-bet',
      typeIs: 'abc',
      abcTicket: this.abcTicket[index].ABCTicket
    });
  }

  removeBet(index: any): void {
    this.abcTicket[index].removed = true;
  }

  submitAll(): void {
    const abcTicket = this.createNewABCTicket(false);

    if (abcTicket.calcAmount() > this.balanceAmount) {
      this.showAlertInfo('Info', 'Insufficient Funds.', 'Deposit Now');
      return;
    }

    this.modalCtrl.dismiss({
      betType: 'bet-now',
      typeIs: 'abc',
      abcTicket
    });
  }

  saveAll(): void {
    const abcTicket = this.createNewABCTicket(false);

    this.modalCtrl.dismiss({
      betType: 'save-bet',
      typeIs: 'abc',
      abcTicket
    });
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  async openFunding(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: FundingComponent,
    });
    modal.present();
  }

  async showAlertInfo(hdr: string, msg: string, btn: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: hdr,
      message: msg,
      buttons: [
        {
          text: btn,
          handler: () => {
            this.ngZone.run(()=>{
              this.modalCtrl.dismiss();
                this.openFunding();
            });
          }
        }
      ]
    });

    await alert.present();
  }

}
